<template>
  <div>
    <list
      row-key="HouseId"
      ref="list"
      unit="任课资料"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canWrite()"
      :show-query="showQuery"
      :get-data-func="api.list"
      :can-search="canSearch"
      :showReset="false"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期名称" v-if="isMB">
          <el-select v-model="TermId" @change="termChange" size="mini">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="班级" v-if="isMB">
          <tree-select
            ref="treeSelect"
            size="mini"
            :props="props"
            :options="TreeData"
            :value="params.ClassId"
            :clearable="false"
            :accordion="true"
            style="width:100%"
            :parentSelect="true"
            placeholder="请选择"
            @node-select="onTreeSelect($event)"
          />
        </el-form-item>
        <el-form-item label="教师姓名">
          <el-input size="mini" v-model="params.Teacher" placeholder="请填写教师姓名" clearable />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column label="班级" min-width="90">
          <template slot-scope="{row}">
            <span>{{row.Grade + row.Class}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Subject" label="科目名称" />
        <el-table-column label="任课教师" min-width="160px">
          <template slot-scope="{row}">
            <span>{{row.Teacher}}</span>
            <span v-if="row.ClassTeacherId==row.TeacherId">（班主任）</span>
          </template>
        </el-table-column>
        <el-table-column prop="TeacherNumber" label="教师编号" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import treeSelect from "@/components/common/treeSelect";
import classApi from "@/api/ed/class";
import termApi from "@/api/ed/term";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: {
    list,
    treeSelect,
    exportDialog,
  },
  data() {
    return {
      api: require("@/api/ed/teach").default,
      termApi,
      classApi,
      params: {
        Teacher: "",
        ClassId: null,
      },
      TermId: null,
      props: {
        // 配置项（必选）
        value: "ClassId",
        label: "ClassName",
        children: "children",
        // disabled:true
      },
      termList: [],
      TreeData: [],
      isMB: this.$store.state.isMB,
    };
  },
  mounted() {
    if (this.isMB) {
      this.termApi.list().then((res) => {
        this.termList = res.Data || [];
        if (res.Data.length > 0) {
          let tid = res.Data[0].TermId;
          this.TermId = tid;
          this.getTreeData(tid);
          this.getData({ TermId: tid });
          sessionStorage.setItem("termId", tid);
        }
      });
    }
  },
  methods: {
    getTreeData(termId) {
      classApi.gradeClassList(termId).then((res) => {
        sessionStorage.setItem("termId", termId);
        this.TreeData = this.$commonJs.toTreeData(res.Data, "ClassId");
      });
    },
    termChange(e) {
      sessionStorage.setItem("termId", e);
      this.getTreeData(e);
      this.getData({ TermId: e });
      this.$refs.treeSelect.clearHandle();
    },
    onTreeSelect(t) {
      if (!t) return;
      if (t.ClassId > 0) {
        this.getData({ ClassId: t.ClassId, TermId: this.TermId });
        this.$emit("setadd", true);
      } else {
        this.getData({ GradeId: -t.ClassId, TermId: this.TermId });
        this.$emit("setadd", false);
      }
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.getData({ TermId: sessionStorage.getItem("termId") || 0 });
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
    export(params) {
      this.$refs.exportDialog.open().then((that) => {
        that.getData({ ...this.params, ...params });
      });
    },
  },
};
</script>